import cx from "classnames";
import QuestionBubbleIcon from "../../icons/question_bubble.svg?react";
import styles from "./PinnedUserMessage.module.css";

type PinnedUserMessageProps = {
  text: string;
  visible: boolean;
  onClick: () => void;
};

export const PinnedUserMessage = ({
  text,
  visible,
  onClick,
}: PinnedUserMessageProps) => (
  <div
    className={cx(styles.root, visible && styles.visible)}
    onClick={onClick}
    onPointerDown={(e) => e.preventDefault()}
    role="button"
    tabIndex={visible ? 0 : -1}
  >
    <span className={styles.text}>{text}</span>
    <QuestionBubbleIcon className={styles.icon} data-mirror-rtl />
  </div>
);
